<template>
    <v-dialog v-model="show" width="600">
        <v-card>

            <v-toolbar dark color="primary">

                <v-toolbar-title>{{ t("ticket", "STR_NEWTICKET") }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon dark @click.stop="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-title>

            </v-card-title>
            <v-card-text>
                <v-form>
                    <v-text-field outlined v-model="localSubject" :label="this.t('ticket', 'STR_SUBJECT')"
                        required></v-text-field>
                    <v-textarea outlined v-model="message" name="input-7-4"
                        :label="this.t('ticket', 'STR_MESSAGE')"></v-textarea>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.stop="show = false"> {{ t("common", "STR_CLOSE") }}</v-btn>
                <v-btn large color="primary" class="ma-2 text--right" @click="submitTicket"
                    :disabled="!localSubject || !message">

                    {{ t('ticket', 'STR_SUBMIT') }}

                </v-btn>

            </v-card-actions>
        </v-card>

    </v-dialog>
</template>


<script>
import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
    props: {
        /**
         * Optional subject line that pre-fills the ticket form.
         * @type {string}
         */
        subjectParam: String,

        /**
         * Controls the visibility of the modal dialog (v-model).
         * @type {boolean}
         */
        value: Boolean,
    },
    data() {
        return {
            localSubject: this.subjectParam, // Locale Copy
            message: "",

        };
    },
    computed: {
        show: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    watch: {
        subjectParam(newVal) {
            this.localSubject = newVal;
        }
    },
    /*watch: {
        showDialog(val) {
            this.displayDialog  = val;
        }
    },*/
    methods: {
        /**
        * Submits the ticket to the backend system.
        * emits success event.
        */
        submitTicket() {
            const t = this;
            t.$store.commit('setLoadingState', true);


            axios({
                method: 'post', url: process.env.VUE_APP_BACKEND_TICKET, params: {
                    subject: t.localSubject,
                    msg: t.message,
                    sesstoken: t.$store.getters.getToken,
                    format: "J"
                }, withCredentials: true
            })
                .then(function (response) {
                    // handle success

                    t.showTicketDialog = false;
                    if (response.data.status === true) {

                        t.$store.dispatch("showMessage", { type: "info", text: response.data.msg });
                        t.message = "";
                        t.show = false
                        t.$emit("ticket-created");
                    } else {
                        t.$store.dispatch("showMessage", { type: "Error", text: response.data.msg });
                    }

                })
                .catch(function (error) {
                    // handle error
                    t.$store.dispatch("showMessage", { type: "Error", text: error.message });

                    console.log(error);
                })
                .finally(function () {
                    // always executed

                    t.$store.commit('setLoadingState', false);

                });
        }
    }
};
</script>